import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_524 implements Validator {

    public static id = 'CTRL_524';
    private message = 'error.ctr_524';


    public LOG: LogService = new LogService(CTRL_524);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_524.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const valeurNameWithStepId = map.get(ctrl.value.rgCtrls.valeur);
                const valeurBasseNameWithStepId = map.get(ctrl.value.rgCtrls.valeurBasse);
                const valeurHauteNameWithStepId = map.get(ctrl.value.rgCtrls.valeurHaute);
                const deviseNameWithStepId = map.get(ctrl.value.rgCtrls.devise);
                const valeurCtrl = form.controls[valeurNameWithStepId];
                const valeurBasseCtrl = form.controls[valeurBasseNameWithStepId];
                const valeurHauteCtrl = form.controls[valeurHauteNameWithStepId];
                const deviseCtrl = form.controls[deviseNameWithStepId];

                if (this.isNotEmptyOrNullOrUndefined(valeurCtrl.value) && (this.isNotEmptyOrNullOrUndefined(valeurBasseCtrl.value) || this.isNotEmptyOrNullOrUndefined(valeurHauteCtrl.value))
                    || (this.isNotEmptyOrNullOrUndefined(valeurCtrl.value) || this.isNotEmptyOrNullOrUndefined(valeurBasseCtrl.value) || this.isNotEmptyOrNullOrUndefined(valeurHauteCtrl.value)) && !this.isNotEmptyOrNullOrUndefined(deviseCtrl.value)
                ) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '');
	}
}
